import React from 'react';
import { useAnswerSetContext } from '../AnswerSets/AnswerSetContext';

function QuestionSettings({ question, className, ...props }) {
  const { getComponents } = useAnswerSetContext();
  const { Settings } = getComponents(question?.type);

  return (
    <div className={className}>
      <Settings question={question} {...props} />
    </div>
  );
}

export default QuestionSettings;
